import { render, staticRenderFns } from "./processSelect.vue?vue&type=template&id=0c6b2413&"
import script from "./processSelect.vue?vue&type=script&lang=js&"
export * from "./processSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports